import React from 'react';

const LivePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
        <iframe
          src="https://player.viloud.tv/embed/channel/947399079419b14dc6b5b47b38a3d3c6?autoplay=1&volume=0&controls=1&title=1&share=1&open_playlist=0&random=1"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          frameBorder="0"
          allow="autoplay"
          allowFullScreen
          title="Effekten Live"
        ></iframe>
      </div>
      <div className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">Effekten Live</h1>
          <p className="text-gray-400">Vi väljer avsnittet åt dig i vår livesändning eller välj själv i spellistan </p>
        </div>
      </div>
    </div>
  );
};

export default LivePage;